import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import { Button } from "reactstrap";
import Upload from "../../Components/upload";

const Setting = () => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({
    address: "",
    email: "",
    skypeId: "",
    interNationalNumber: "",
    domesticNumber: "",
    complaintNumber: "",
    mapUrl: "",
    metatitle: "",
    metakeyword: "",
    metadescription: "",
    copyRightText: "",
    headerLogo: "",
    footerLogo: "",
    favIcon: "",
    notification: "",
    showProductCount: "",
    showPrice: false,
    timing: "",
   wholeSaleCheckout: {
      count: 5,
      countEnable: false,
      priceEnabled: false,
      totalPrice: "",
    },
    semiWholeSaleCheckout: {
      count: 5,
      countEnable: false,
      priceEnabled: false,
      totalPrice: "",
      bypassIfCatalogueExists: true,
    },
    purchaseType: "retail",
    layout: "center",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axiosInstance.get(`/websetting`);
      const { data } = response.data;
      setData((prev) => ({ ...prev, ...data }));
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    }
  };

  const handleChange = (e, section = null) => {
    const { name, type, value, checked } = e.target;
    const finalValue = type === "checkbox" ? checked : value;

    if (section) {
      setData((prev) => {
        let updatedSection = { ...prev[section], [name]: finalValue };
        if (name === "countEnable" && checked) updatedSection.priceEnabled = false;
        if (name === "priceEnabled" && checked) updatedSection.countEnable = false;

        return { ...prev, [section]: updatedSection };
      });
    } else {
      setData((prev) => ({
        ...prev,
        [name]: name === "showPrice" ? value === "true" : finalValue,
      }));
    }
  };



  const handleUpdate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axiosInstance.post(`/websetting`, data);
      if (response.status === 200) {
        toast.success(response.data.message);
        fetchData();
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again!!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="page-header mt-5">
        <h3 className="page-title">Website Settings</h3>
      </div>

      <div className="row grid-margin stretch-card">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <form className="pt-3" onSubmit={handleUpdate}>
                <div className="pe-2 border rounded border-secondary">
                  <div className="mb-2">
                    <div className="row mx-3">
                      {/* Logos */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="col-form-label">Header Logo</label>
                          <Upload
                            label="headerLogo"
                            initialImage={data.headerLogo}
                            onChange={(imgUrl) =>
                              setData((prev) => ({ ...prev, headerLogo: imgUrl }))
                            }
                            apiUrl={"uploads?label=settings"}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="col-form-label">Footer Logo</label>
                          <Upload
                            label="footerLogo"
                            initialImage={data.footerLogo}
                            onChange={(imgUrl) =>
                              setData((prev) => ({ ...prev, footerLogo: imgUrl }))
                            }
                            apiUrl={"uploads?label=settings"}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="col-form-label">Favicon</label>
                          <Upload
                            label="favIcon"
                            initialImage={data.favIcon}
                            onChange={(imgUrl) =>
                              setData((prev) => ({ ...prev, favIcon: imgUrl }))
                            }
                            apiUrl={"uploads?label=settings"}
                          />
                        </div>
                      </div>

                      {/* Contact Info */}
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">International Number</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="interNationalNumber"
                            value={data.interNationalNumber}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Domestic Contact Number</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="domesticNumber"
                            value={data.domesticNumber}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Complaint Number</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="complaintNumber"
                            value={data.complaintNumber}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Website Email</label>
                          <input
                            type="email"
                            className="form-control form-control-sm border border-dark"
                            name="email"
                            value={data.email}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Website Skype Id</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="skypeId"
                            value={data.skypeId}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Header Top Text</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="notification"
                            value={data.notification}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Home Product Slider Count</label>
                          <input
                            type="number"
                            className="form-control form-control-sm border border-dark"
                            name="showProductCount"
                            value={data.showProductCount}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Office Timing</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="timing"
                            value={data.timing}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Copy Rights Text</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="copyRightText"
                            value={data.copyRightText}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      {/* Address & Map */}
                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="col-form-label">Website Address</label>
                          <textarea
                            className="form-control form-control-sm border border-dark"
                            name="address"
                            value={data.address}
                            onChange={handleChange}
                            rows={4}
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="form-group">
                          <label className="col-form-label">Map Url</label>
                          <textarea
                            className="form-control form-control-sm border border-dark"
                            name="mapUrl"
                            value={data.mapUrl}
                            onChange={handleChange}
                            rows={4}
                          />
                        </div>
                      </div>

                      {/* Meta */}
                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Meta Title</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="metatitle"
                            value={data.metatitle}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Meta Keyword</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="metakeyword"
                            value={data.metakeyword}
                            onChange={handleChange}
                          />
                        </div>
                      </div>

                      <div className="col-sm-4">
                        <div className="form-group">
                          <label className="col-form-label">Meta Description</label>
                          <input
                            type="text"
                            className="form-control form-control-sm border border-dark"
                            name="metadescription"
                            value={data.metadescription}
                            onChange={handleChange}
                          />
                        </div>
                      </div>


<div className="col-sm-12">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <hr />
                                                            <h5>Website Layout</h5>
                                                        </div>

                                                        <div className="col-sm-12 col-md-4">
                                                            <div className="form-group ">
                                                                <label
                                                                    htmlFor="exampleInputUsername2"
                                                                    className="col-form-label "
                                                                >
                                                                    Layout
                                                                </label>
                                                                <div className="d-flex">
                                                                    <div className="form-check form-check-inline d-flex">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="layout"
                                                                            id="center"
                                                                            value="center"
                                                                            checked={data.layout === "center"}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <label className="form-check-label ml-0" htmlFor="layout">
                                                                            Center
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check form-check-inline d-flex mx-4">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="layout"
                                                                            id="fullwidth"
                                                                            value="fullwidth"
                                                                            checked={data.layout === "fullwidth"}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <label className="form-check-label ml-0" htmlFor="fullwidth">
                                                                            Full width
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="col-sm-12 col-md-4">
                                                            <div className="form-group ">
                                                                <label
                                                                    htmlFor="exampleInputUsername2"
                                                                    className="col-form-label "
                                                                >
                                                                    Purchase Type
                                                                </label>
                                                                <div className="d-flex">
                                                                    <div className="form-check form-check-inline d-flex">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="purchaseType"
                                                                            id="retail"
                                                                            value="retail"
                                                                            checked={data.purchaseType === "retail"}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <label className="form-check-label ml-0" htmlFor="retail">
                                                                            Retail
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check form-check-inline d-flex mx-4">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="purchaseType"
                                                                            id="wholesale"
                                                                            value="wholesale"
                                                                            checked={data.purchaseType === "wholesale"}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <label className="form-check-label ml-0" htmlFor="wholesale">
                                                                            WholeSale
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        <div className="col-sm-12 col-md-4">
                                                            <div className="form-group ">
                                                                <label
                                                                    htmlFor="exampleInputUsername2"
                                                                    className="col-form-label "
                                                                >
                                                                    Login is required (For price)
                                                                </label>
                                                                <div className="d-flex">
                                                                    <div className="form-check form-check-inline d-flex">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="showPrice"
                                                                            id="showPriceTrue"
                                                                            value="false"
                                                                            checked={data.showPrice === false}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <label
                                                                            className="form-check-label ml-0"
                                                                            htmlFor="showPriceTrue"
                                                                        >
                                                                            Yes
                                                                        </label>
                                                                    </div>
                                                                    <div className="form-check form-check-inline d-flex mx-4">
                                                                        <input
                                                                            className="form-check-input"
                                                                            type="radio"
                                                                            name="showPrice"
                                                                            id="showPriceFalse"
                                                                            value="true"
                                                                            checked={data.showPrice === true}
                                                                            onChange={handleChange}
                                                                        />
                                                                        <label
                                                                            className="form-check-label ml-0"
                                                                            htmlFor="showPriceFalse"
                                                                        >
                                                                            No
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>




                      {/* Checkout Section */}
                      <div className="col-12 mt-4">
                        <hr />
                        <h4>Checkout Condition</h4>
                      </div>

                      {/* Wholesale Checkout */}
                      <div className="col-md-6">
                        <h5>Wholesale Checkout</h5>
                        <div className="form-group">
                          <label>Number of Catalogue</label>
                           <select
                      name="count"
                      className="form-control form-control-sm border border-dark"
                      value={data.wholeSaleCheckout.count}
                      onChange={(e) => handleChange(e, "wholeSaleCheckout")}
                    >
                      {[1,2,3,4,5,6,7,8,9,10].map(i => (
                        <option key={i} value={i}>{i}</option>
                      ))}
                    </select>

                        </div>

                                           <div className="form-check mt-2">
                      <input
                        type="checkbox"
                        name="countEnable"
                        checked={data.wholeSaleCheckout.countEnable}
                        onChange={(e) => handleChange(e, "wholeSaleCheckout")}
                      />
                      <label className="ml-2">Enable Min Catalogue Count</label>
                    </div>


                        <div className="form-check mt-2">
                      <input
                        type="checkbox"
                        name="priceEnabled"
                        checked={data.wholeSaleCheckout.priceEnabled}
                        onChange={(e) => handleChange(e, "wholeSaleCheckout")}
                      />
                      <label className="ml-2">Enable Min Total Price</label>
                    </div>

                       {data.wholeSaleCheckout.priceEnabled && (
                      <input
                        type="number"
                        name="totalPrice"
                        className="form-control form-control-sm border border-dark mt-2"
                        value={data.wholeSaleCheckout.totalPrice}
                        onChange={(e) => handleChange(e, "wholeSaleCheckout")}
                      />
                    )}
                      </div>

                      {/* Semi Wholesale Checkout */}
                      <div className="col-md-6">
                        <h5>Semi Wholesale Checkout</h5>
                        <div className="form-group">
                          <label>Number of Products</label>
                          <select
                      name="count"
                      className="form-control form-control-sm border border-dark"
                      value={data.semiWholeSaleCheckout.count}
                      onChange={(e) => handleChange(e, "semiWholeSaleCheckout")}
                    >
                      {[1,2,3,4,5,6,7,8,9,10].map(i => (
                        <option key={i} value={i}>{i}</option>
                      ))}
                    </select>
                        </div>

                        <div className="form-check mt-2">
                      <input
                        type="checkbox"
                        name="countEnable"
                        checked={data.semiWholeSaleCheckout.countEnable}
                        onChange={(e) => handleChange(e, "semiWholeSaleCheckout")}
                      />
                      <label className="ml-2">Enable Min Product Count</label>
                    </div>

                        <div className="form-check mt-2">
                      <input
                        type="checkbox"
                        name="priceEnabled"
                        checked={data.semiWholeSaleCheckout.priceEnabled}
                        onChange={(e) => handleChange(e, "semiWholeSaleCheckout")}
                      />
                      <label className="ml-2">Enable Min Total Price</label>
                    </div>


                         {data.semiWholeSaleCheckout.priceEnabled && (
                      <input
                        type="number"
                        name="totalPrice"
                        className="form-control form-control-sm border border-dark mt-2"
                        value={data.semiWholeSaleCheckout.totalPrice}
                        onChange={(e) => handleChange(e, "semiWholeSaleCheckout")}
                      />
                    )}

                      <div className="form-check mt-2">
                      <input
                        type="checkbox"
                        name="bypassIfCatalogueExists"
                        checked={data.semiWholeSaleCheckout.bypassIfCatalogueExists}
                        onChange={(e) => handleChange(e, "semiWholeSaleCheckout")}
                      />
                      <label className="ml-2">Bypass if catalogue exists</label>
                    </div>
                      </div>

                    </div>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? "Updating..." : "Submit"}
                  </Button>
                  <Link to="/dashboard">
                    <Button color="danger" className="ml-3">
                      Cancel
                    </Button>
                  </Link>
                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;
